import styled from '@emotion/styled'

export const StyledProgressWrapper = styled.div`
  position: relative;
  min-width: 170px;
  min-height: 26px;
`

export const StyledInactiveBarWrapper = styled.div`
  position: absolute;
  display: flex;
`
export const StyledAtiveBarWrapper = styled.div`
  position: absolute;
  display: flex;
`

export const StyledActiveBar = styled.div`
  width: 10px;
  height: 26px;
  margin-right: 7px;
  background: #2d87f3;
  border-radius: 4px;
  opacity: 0;
`

export const StyledInactiveBar = styled.div`
  width: 10px;
  height: 26px;
  margin-right: 7px;
  background: #284680;
  border-radius: 4px;
`
